import { GRAY_0, TRIMBLE_GRAY } from './mc-tokens';

const MC_COMMENTS_ATTACHMENT_LIST = '.mc-comments__attachment-list';
const MC_COMMENTS_ATTACHMENT_ROW = `${MC_COMMENTS_ATTACHMENT_LIST} .group-items`;

/** Shared layout for attachment rows across saved, edit, and composer contexts. */
export const MC_COMMENTS_ATTACHMENT_ROW_CSS = `
  ${MC_COMMENTS_ATTACHMENT_ROW} {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 0.75rem;
    min-height: 2.5rem;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border: none;
    isolation: isolate;
    gap: 0.75rem
    padding: 0;
  }


  ${MC_COMMENTS_ATTACHMENT_LIST} .list-item .group-items.px-0 {
    padding-left: 0;
    padding-right: 0;
  }

  ${MC_COMMENTS_ATTACHMENT_ROW} .block {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
  }

  ${MC_COMMENTS_ATTACHMENT_LIST} .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    text-align: left;
  }

  ${MC_COMMENTS_ATTACHMENT_LIST} .group-items small,
  ${MC_COMMENTS_ATTACHMENT_ROW} .mc-comments__attachment-list-title,
  ${MC_COMMENTS_ATTACHMENT_ROW} tc-modus-typography,
  ${MC_COMMENTS_ATTACHMENT_ROW} modus-wc-typography {
    font-size: 0.75rem !important;
    color: ${TRIMBLE_GRAY};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ${MC_COMMENTS_ATTACHMENT_ROW} > i,
  ${MC_COMMENTS_ATTACHMENT_ROW} .icon-font.i16 {
    line-height: 1;
    height: 1rem;
    width: 1rem;
    flex: 0 0 1rem;
    color: var(--modus-wc-color-base-content-low-contrast);
  }

  ${MC_COMMENTS_ATTACHMENT_ROW} img,
  ${MC_COMMENTS_ATTACHMENT_ROW} img.i16 {
    width: 1rem;
    height: 1rem;
    max-width: 1rem;
    max-height: 1rem;
    object-fit: contain;
    flex: 0 0 1rem;
  }

  ${MC_COMMENTS_ATTACHMENT_ROW} tc-button,
  ${MC_COMMENTS_ATTACHMENT_ROW} modus-wc-button {
    flex: 0 0 auto;
    margin-left: auto;
    width: auto;
    display: inline-flex;
  }

  ${MC_COMMENTS_ATTACHMENT_ROW} modus-wc-button button.modus-wc-btn {
    width: 2rem;
    min-width: 2rem;
    height: 2rem;
    min-height: 2rem;
    padding: 0.25rem;
  }

  ${MC_COMMENTS_ATTACHMENT_ROW} modus-wc-button modus-wc-icon i {
    font-size: 1rem;
    line-height: 1rem;
    width: 1rem;
    height: 1rem;
  }
`;

/** Hover overlay for clickable saved attachment rows only. */
export const MC_COMMENTS_ATTACHMENT_ROW_INTERACTIVE_CSS = `
  .mc-comments__saved-attachments ${MC_COMMENTS_ATTACHMENT_LIST} .list-item.group .group-items.item-btn {
    cursor: pointer;
    padding: 0 1rem;
  }

  .mc-comments__saved-attachments ${MC_COMMENTS_ATTACHMENT_LIST} .list-item.group .group-items.item-btn::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
  }

  .mc-comments__saved-attachments ${MC_COMMENTS_ATTACHMENT_LIST} .list-item.group .group-items.item-btn:hover::before {
    background-color: ${GRAY_0};
  }

  .mc-comments__saved-attachments ${MC_COMMENTS_ATTACHMENT_LIST} .group-items.item-btn > * {
    position: relative;
    z-index: 1;
  }
`;

/** List container resets for attachment lists in comment contexts. */
export const MC_COMMENTS_ATTACHMENT_LIST_RESET_CSS = `
  ${MC_COMMENTS_ATTACHMENT_LIST} {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .mc-comments__edit-attachments ${MC_COMMENTS_ATTACHMENT_LIST} {
    margin-bottom: 0.25rem;
  }

  .mc-comments__saved-attachments ${MC_COMMENTS_ATTACHMENT_LIST}.mt-1 {
    margin-top: 0.25rem;
  }

  ${MC_COMMENTS_ATTACHMENT_LIST}.mb-1,
  ${MC_COMMENTS_ATTACHMENT_LIST}#attachment-list.mb-1 {
    margin-bottom: 0.5rem !important;
  }

  ${MC_COMMENTS_ATTACHMENT_LIST} .list-item.group {
    padding: 0;
    list-style: none;
  }

  .mc-comments__saved-attachments ${MC_COMMENTS_ATTACHMENT_LIST},
  .mc-comments__saved-attachments ${MC_COMMENTS_ATTACHMENT_LIST} .list-item.group {
    width: 100%;
    max-width: 100%;
  }
`;
